import { controlTypes } from './control-types';

export default class LiveArrowControlStrategy {
    static carousel(type, onClickPrevBtn, onClickNextBtn) {
        if (type === controlTypes.prev) {
            onClickPrevBtn();
        }

        if (type === controlTypes.next) {
            onClickNextBtn();
        }
    }

    static hole(holeId, type, holesLength, renderHole) {
        let currentHoleId = holeId;

        if (type === controlTypes.next) {
            if (currentHoleId >= holesLength) currentHoleId = 0;
            currentHoleId += 1;
        }

        if (type === controlTypes.prev) {
            if (currentHoleId === 1) currentHoleId = holesLength + 1;
            currentHoleId -= 1;
        }

        renderHole(currentHoleId);
    }
}
